import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import st from './AnalyticStatus.module.sass';

export const StatusBadge = ({ status }) => {
  const { t } = useTranslation();

  return (
    <span className={cn(st.Status, st[`StatusColors_${status}`])}>
      <span aria-hidden className={st.Dot} />
      <span>
        {t(`videoAnalytics:request_status.${status}`, { defaultValue: '' })}
      </span>
    </span>
  );
};

export const AnalyticStatus = ({ name, status, children }) => (
  <div
    className={st.AnalyticStatus}
    data-testid={`StreamAnalyticName_${name}`}
  >
    <span className={st.StatusNameText}>{name}</span>
    {children ?? <StatusBadge status={status} />}
  </div>
);
